import React from 'react';
import Lottie from 'react-lottie';

import loader1 from './data1.json';
import loader2 from './data2.json';
import loader3 from './data3.json';
import loader4 from './data4.json';
import loader5 from './data5.json';
import loader6 from './data6.json';
import loader7 from './data7.json'; // global

const loaders = {loader1, loader2, loader3, loader4, loader5, loader6, loader7};

interface Props {isLoaded?: boolean, loaderId: number, height: number, width: number}

function Loader(props: Props) {
    const {width, height, isLoaded, loaderId} = props;

    const objKey = `loader${loaderId}`;
    const animationData = loaders[objKey];

    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return (
      <div>
        <Lottie options={defaultOptions} height={height} width={width} />
      </div>
    );
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/PlexLoader/Loader.tsx